export const PRIMARY_COLOR = "#003049";
export const PRIMARY_COLOR_40 = '#024466'

export const SECONDARY_COLOR = "#FF9462";

export const GRAY_10 = '#D4D4D4';
export const GRAY_20 = '#B4B4B4';
export const GRAY_30 = '#909090';
export const GRAY_40 = '#636363';
export const GRAY_50 = '#494848';

export const ERROR_COLOR: {[index: number] : string} = {
     50: '#FFEBEE',
    100: '#FFCDD2',
    200: '#EF9A9A',
    300: '#E57373',
    400: '#EF5350',
    500: '#F44336',
    600: '#E53935',
    700: '#D32F2F',
    800: '#C62828',
    900: '#B71C1C'
}